import styles from "./project.module.css";
import OneSkill from "../Skills/OneSkill";

const StarWars = () => {
  return (
    <div className={styles.projects_container}>
      <div className={styles.project}>
        <div className={styles.project_videocontainer}>
          <div data-aos="fade-right">
            <img src="https://i.ibb.co/2M0SJdV/starWars.png" alt="StarWars" />
          </div>
        </div>
        <div className={styles.project_information}>
          <h2>Star Wars</h2>
          <p>
            {" "} 
         <b> An API used for throttling effect(debouncing).</b><br/>
            Debouncing is a programming technique used by developers to limit
            the number of calls to an event or only trigger a function when
            needed or for only one use case.{" "}
          </p>{" "}
          <div className={styles.project_skills}>
            <OneSkill skill="vscode-icons:file-type-html" sName="HTML" /> 
            <OneSkill skill="vscode-icons:file-type-css" sName="CSS" /> 
             
            <OneSkill skill="logos:javascript" sName="JavaScript" /> 
             
          </div>
          <div>
            <a
              href="https://ankitkumar3443.github.io/start_wars.github.io/"
              target="_blank"
              rel="noreferrer"
            >
              <span type="button" className="btn-blue_active">
                See this Live
              </span>
            </a>
            <a
              href="https://github.com/ankitkumar3443/start_wars.github.io"
              target="_blank"
              rel="noreferrer"
            >
              <span type="button" className="btn-blue">
                View Code
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StarWars;
